import { render } from "./LabelPage.vue?vue&type=template&id=21e2438d&ts=true"
import script from "./LabelPage.ts?vue&type=script&lang=ts&external"
export * from "./LabelPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__